/**
 * Warstwa API: RAPORT DAILY Z KOLEJKI MODUŁU (S23, 2026-09-14).
 *
 * Trasa backendu: `POST api/tickets/{ticketId}/raport-daily`.
 *
 * Właściciel: „Raport daily jest tylko dla pracowników przypisanych do modułu z którego jest robiony”.
 * Serwer sprawdza w JEDNYM żądaniu: klucz `TicketResponse`, tytuł wołającego do modułu `moduleCode`,
 * przynależność zgłoszenia do tego modułu i to, że każdy adresat zadania TODO jest w obsadzie modułu.
 * Dopiero wtedy zapisuje notatkę `[Raport daily]` i zadania.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do
 * wspólnego `apiService` (nazwy unikalne w całej aplikacji — patrz attachApiModules).
 */
export function attach(api) {
    return {
        /**
         * Zapis jednej pozycji raportu. `notatka: null` = notatka już zapisana (ponowienie po częściowej awarii).
         * Odpowiedź: `{ notatkaZapisana, zadania: [{ userId, ok, blad }] }`.
         * @param {string} ticketId
         * @param {{ moduleCode: string, notatka: string|null, zadania: Array }} pozycja
         */
        zapiszPozycjeRaportuDaily: (ticketId, pozycja) =>
            api.post(`/tickets/${ticketId}/raport-daily`, pozycja),
    };
}
